export default {
  presenter: 'krcmar',
  title: 'Šifrovaný disk v Linuxu',
  subtitle: 'začátečníci',
  text: `
Svá data bychom měli dobře chránit a základem je šifrování disků. V Linuxu existuje několik
různých způsobů, jak to dělat. Představíme si je a prakticky předvedeme.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/krcmar-sifrovany-disk.js